/**
 *
 *  Cookie Consent pop-up
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 23/05/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useRef, useState } from "react";
// import PropTypes from "prop-types";
// import Modal from "react-modal";
import Cookies from "js-cookie";

// Components
import Button from "../Button/Button";

// Hooks
import useTheme from "../ThemeProvider/useTheme/useTheme";

// Icons
import CloseIcon from "../../icons/CloseIcon";

// Utils
import { clientWidth } from "../../utils";
import { modalStyles } from "../../constants";

// Images
import Cookie from "./Cookie";

import Transition, {
  ENTERED,
  ENTERING,
  EXITED,
  EXITING,
} from "react-transition-group/Transition";

const transitionClasses = {
  [ENTERED]: "cookie-consent-popup-transition-entered",
  [ENTERING]: "cookie-consent-popup-transition-entering",
  [EXITING]: "cookie-consent-popup-transition-exiting",
  [EXITED]: "cookie-consent-popup-transition-exited",
};

const COOKIE_CONSENT_POPUP_DELAY = 3000;

const CookieConsent = () => {
  const { theme } = useTheme();

  const cookieModalCustomStyle =
    clientWidth() < theme.responsive.breakpoints.sm
      ? modalStyles.cookiePopupMobile
      : modalStyles.cookiePopup;

  const [showAcceptCookiePopup, setShowAcceptCookiePopup] = useState(false);

  const cookieConsentPopupRef = useRef(null);

  const setCookieCheck = React.useCallback(() => {
    var date = new Date();

    date.setDate(date.getDate() + 30);

    const cookieOptions = { path: "/", expires: date };

    Cookies.set("cookie-check", "all", cookieOptions);
  }, []);

  React.useEffect(() => {
    if (
      "set" !== Cookies.get("cookie-check") &&
      "all" !== Cookies.get("cookie-check")
    ) {
      setTimeout(() => {
        setShowAcceptCookiePopup(true);
      }, COOKIE_CONSENT_POPUP_DELAY);

      const handleOutsideClick = (e) => {
        if (e.target.closest("#accept-cookie-all")) {
          return;
        }

        setCookieCheck();
        setShowAcceptCookiePopup(false);
        document.removeEventListener("click", handleOutsideClick);
      };

      document.addEventListener("click", handleOutsideClick);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAcceptAllClick = React.useCallback(() => {
    setCookieCheck();

    setShowAcceptCookiePopup(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFunctionalOnlyClick = React.useCallback(() => {
    var date = new Date();

    date.setDate(date.getDate() + 30);

    const cookieOptions = { path: "/", expires: date };

    Cookies.set("cookie-check", "set", cookieOptions);

    setShowAcceptCookiePopup(false);
  }, []);

  const closeAcceptCookiePopup = React.useCallback(() => {
    setShowAcceptCookiePopup(false);
  }, []);

  return (
    <Transition
      nodeRef={cookieConsentPopupRef}
      in={showAcceptCookiePopup}
      timeout={300}
      // addEndListener={this.handleTransitionEnd}
    >
      {(status, innerProps) => (
        <div
          // className="modal-cookies md:tbk-p-4_ "
          ref={cookieConsentPopupRef}
          className={`tbk-fixed tbk-right-0 tbk-bottom-0 tbk-left-0 tbk-z-995 tbk-rounded-tl-2xl tbk-bg-basic-white tbk-px-2 tbk-pt-2 tbk-pb-5 tbk-shadow-trube tbk-transition-transform tbk-duration-300 md:tbk-left-auto md:tbk-w-116 ${
            status === ENTERING || status === EXITED
              ? "tbk-translate-y-full tbk-opacity-5"
              : status === EXITING
              ? "tbk-translate-y-full tbk-opacity-5"
              : "tbk-translate-y-0 tbk-opacity-100"
          } ${transitionClasses[status]}`}
        >
          <button
            onClick={closeAcceptCookiePopup}
            className="tbk-absolute tbk-top-2 tbk-right-2 tbk-z-10 tbk-hidden tbk-text-coral"
          >
            <CloseIcon />
          </button>
          <div className="tbk-flex">
            <Cookie className="tbk-mr-2 tbk-shrink-0" />
            <p className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
              This website uses cookies to ensure you get the best experience on
              our website.{" "}
              <a
                href="/terms/TruBe - US Privacy Policy.pdf"
                target="_blank"
                className="tbk-text-main tbk-text-grey tbk-underline hover:tbk-text-grey-inactive"
              >
                Read more
              </a>
            </p>
          </div>
          <a id="accept-cookie-all" className="" onClick={handleAcceptAllClick}>
            <Button variant="basic" className="tbk-block tbk-w-full" size="md">
              Okay
            </Button>
          </a>
        </div>
      )}
    </Transition>
  );
};

CookieConsent.displayName = "CookieConsent";

export default CookieConsent;
